<template>
    <!-- <splashLoader /> -->
    <router-view />
    <Toast group="message" :pt="{
        messageIcon: {
            style: { 'margin-top': '3px' }
        }
    }" />
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAuth as useAuthApi } from "@/api";
import { useUserSession } from "@/stores/userSession";
import { useDeploymentSettingsStore } from "@/stores/deploymentSettings";

const { verifyLoginTokenApi } = useAuthApi();
const router = useRouter();
const route = useRoute();
const deploymentSettingsStore = useDeploymentSettingsStore();

async function checkToken() {
    const userSession = useUserSession();
    const response: any = await verifyLoginTokenApi({ token: userSession.token });
    if (response.status === 'error') {
        router.push({ name: 'login' });
        return;
    }
    await deploymentSettingsStore.fetchSettings(true);
}

onMounted(() => {
    if(route.name != undefined && route.name !== 'login') {
        checkToken();
    }
});

document.addEventListener("visibilitychange", () => {
  if (document.visibilityState === "visible" && router.currentRoute.value.name !== 'login') {
    checkToken();
  }
});
</script>

<style>
::-webkit-scrollbar {
    width: 7px !important;
    height: 7px !important;
}

/* Track */
::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    background-color: #f5f5f5;
}

/* Handle */
::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    /* background-color: #babac0; */
    background-color: var(--primary-color);
    min-height: 30px;
}
</style>
